<template>
  <!-- Where the stock changes. It sits where the scope pills sit, and Tab reaches it the same way. -->
  <div class="flex flex-wrap items-center gap-2 border-b border-surface-200 px-4 py-3">
    <button
      :aria-label="ariaLabel"
      :class="CHIP_CLASS"
      type="button"
      @click="emit('change')"
    >
      <MaterialIcon ligature="location_on" />
      {{ label }}
      <MaterialIcon
        ligature="expand_more"
        size="1rem"
      />
    </button>
    <span
      v-if="location"
      class="text-xs text-surface-500"
    >
      Stock changes here
    </span>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import MaterialIcon from '@/components/atoms/icons/material-icon/MaterialIcon.vue'
import { PALETTE_PILL_CLASS, PALETTE_PILL_IDLE_CLASS } from '@/domains/command-center/types/consts/PalettePill.consts'

import type { TwnStockLocationChipEmits, TwnStockLocationChipProps } from './TwnStockLocationChip.types'

const props = defineProps<TwnStockLocationChipProps>()
const emit = defineEmits<TwnStockLocationChipEmits>()

/** The scope pills' own shape, never switched on. */
const CHIP_CLASS = [PALETTE_PILL_CLASS, PALETTE_PILL_IDLE_CLASS] as const

const label = computed(() => props.location?.name ?? 'Choose a location')

const ariaLabel = computed(() =>
  props.location ? `Location: ${props.location.name}. Change location` : 'Choose a location'
)
</script>
